"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

var _styledComponents = require("styled-components");

/**
 * Hook that gets styled components theme context
 */
var useStyledTheme = function useStyledTheme() {
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  return theme || {};
};

var _default = useStyledTheme;
exports["default"] = _default;